<template>
  <div v-if="hasRemainingTasks" class="mt-24">
    <Card class="w-full">
      <h2 class="bg-primary-subdued px-16 py-8 text-strong-body text-primary rounded-t-lg">Actions to complete</h2>
      <PhotoUploadTask v-if="noProfilePhoto" />
    </Card>
  </div>
</template>

<script lang="ts">
import { Account } from '../../../../lib/public_api/Account';
import Card from '../../../../components/card/Card.vue';
import PhotoUploadTask from './PhotoUploadTask.vue';

export default {
  name: 'OnboardingTasks',
  components: { Card, PhotoUploadTask },
  props: {
    account: {
      required: true,
      type: Account,
    },
  },
  computed: {
    noProfilePhoto(): boolean {
      return !this.account.croppedPhoto;
    },
    hasRemainingTasks(): boolean {
      return this.noProfilePhoto;
    },
  },
};
</script>

<style scoped>
.card {
  padding: 0;
}
</style>
